import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import SellerLayout from './components/SellerLayout';
import LogoPage from '../SellerStack/components/StoreComponents/LogoPage';
import PageTwo from '../SellerStack/components/StoreComponents/PageTwo';
import PageThree from '../SellerStack/components/StoreComponents/PageThree';
import Breadcrumb from '../SharedComponents/components/Breadcrumb/Breadcrumb';
import { getUserFiltersData } from '../SellerStack/reduxStore/entities/userFiltersStore';

const Store = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [selectedMake, setSelectedMake] = useState(null);
  const [selectedCars, setSelectedCars] = useState([]);
  const { filters: userFilters } = useSelector((state) => state.userFiltersStore);
  const maxMakesAllowed = 3;

  useEffect(() => {
    dispatch(getUserFiltersData());
  }, [dispatch]);

  useEffect(() => {
    if (userFilters && userFilters.length > 0) {
      setStep(3);
    }
  }, [userFilters]);

  const breadcrumbs = [
    { title: 'Početak', href: '#' },
    { title: 'Asortiman', href: '#' },
    { title: 'Dodaj modele automobila', href: '#' },
  ];

  const handleLogoClick = (make) => {
    setSelectedMake(make);
    setStep(2);
  };

  const handleBack = () => {
    setSelectedMake(null);
    setStep(1);
  };

  const handleConfirmSelection = (data) => {
    setSelectedCars(prev => [...prev, data]);
    setStep(3);
  };

  const handleRemoveModel = (makeId) => {
    setSelectedCars(prev => prev.filter(car => car.id_car_make !== makeId));
  };

  const handleAddMore = () => {
    if (userFilters.length < maxMakesAllowed) {
      setStep(1);
      setSelectedMake(null);
    }
  };

  return (
    <div className="home-page" style={styles.pageContainer}>
      <SellerLayout>
        <Breadcrumb title={'Dodaj modele automobila'} breadcrumbs={breadcrumbs} />
        {step === 1 && userFilters.length < maxMakesAllowed && <LogoPage onLogoClick={handleLogoClick} />}
        {step === 2 && selectedMake && (
          <PageTwo
            selectedMake={selectedMake}
            onGoBack={handleBack}
            onConfirm={handleConfirmSelection}
          />
        )}
        {step === 3 && (
          <PageThree
            selectedCars={selectedCars}
            onRemoveModel={handleRemoveModel}
            onAddMore={handleAddMore}
            maxMakesAllowed={maxMakesAllowed}
          />
        )}
      </SellerLayout>
    </div>
  );
};

export default Store;

const styles = {
  pageContainer: {
    backgroundColor: '#FFF',
    minHeight: '100vh',
  },
};
